<template>
    <SearchInput
        :unit-before="unitBefore"
        :unit-after="unitAfter"
        :placeholder="placeholder"
        :model-value="modelValue"
        :type="type"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script>
import SearchInput from '../listings/search-input.vue';

// Commercial alias for the shared search field API.
export default {
    components: { SearchInput },
    props: {
        unitBefore: { type: String, default: '' },
        unitAfter: { type: String, default: '' },
        placeholder: { type: String, default: '' },
        modelValue: { type: [String, Number], default: '' },
        type: { type: String, default: '' },
    },
    emits: ['update:modelValue'],
};
</script>
